module.exports = __webpack_public_path__ + "img/Login – 3.2d084e7b.png";